<template>
  <div
    class="sb-filters-activator"
    @click="toggleActivator"
  >
    <span class="sb-filters-activator__text">
      <!--
        @slot text, components, or HtmlElements as children of the component
      -->
      <slot />
    </span>
    <i
      aria-hidden="true"
      class="sb-filters-activator__icon sb-icon-caret-down"
      :class="{'sb-filters-activator__icon--expanded': value}"
    />
  </div>
</template>

<script>
/**
 * Dropdown button that activates the filter dropdown.
 */
export default {
  name: 'SbFiltersActivator',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    /**
    * Emitted when the dropdown is toggled
    */
    'update:modelValue',
  ],
  methods: {
    toggleActivator() {
      this.$emit('update:modelValue', !this.value);
    },
  },
};
</script>

<style lang='scss'>
@import '@src/components/Filter/style/sb-filters-activator.scss';
</style>
